import { NgModule } from '@angular/core';
import { TesteJornadasDigitaisComponent } from './teste-jornadas-digitais.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FooterModule } from './components/footer/footer.module';
import { HeaderModule } from './components/header/header.module';
import { InicioModule } from './components/main/inicio/inicio.module';
import { EnvioModule } from './components/main/envio/envio.module';
import { FinalModule } from './components/main/final/final.module';

@NgModule({
    declarations: [
        TesteJornadasDigitaisComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        HeaderModule,
        InicioModule,
        EnvioModule,
        FinalModule,
        FooterModule
    ],
    exports: [
        TesteJornadasDigitaisComponent
    ]
})

export class TesteJornadasDigitaisModule { }
